import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class TooSmallPercentageDiscountValueWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.common.validation.items.discount-value.too-small-percentage-discount');
    }
}

export class TooSmallQuotaDiscountValueWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.common.validation.items.discount-value.too-small-quota-discount');
    }
}
